/* eslint-disable @typescript-eslint/no-explicit-any */
import { isClient } from "@/lib/common";

export const isNullOrUndefined = (obj: any) => obj === null || obj === undefined;

export const isNumber = (val: any): val is number => !isNullOrUndefined(val) && !isNaN(val);

export const isJson = (str: string): boolean => {
    try {
        JSON.parse(str);
    } catch {
        return false;
    }
    return true;
};

export const isChrome =
    (isClient && navigator?.userAgentData?.brands?.some((brand) => brand.brand === "Google Chrome")) || false;

export const isEdgeChromium =
    (isClient && navigator?.userAgentData?.brands?.some((brand) => brand.brand === "Microsoft Edge")) ||
    false;

export const isFirefox = isClient && typeof (window as any).InstallTrigger !== "undefined";
